function initSearchPosition() {

  const search = document.querySelector('.search-modal');
  const headerWrapper = document.querySelector('.section-header');

  if (!search || !headerWrapper) return;

  const updateSearchPosition = () => {

    const headerBottom = headerWrapper.getBoundingClientRect().bottom;

    search.style.top = headerBottom + "px";

  };

  updateSearchPosition();

  window.addEventListener("scroll", updateSearchPosition);
  window.addEventListener("resize", updateSearchPosition);

}

/* Page load */
document.addEventListener("DOMContentLoaded", initSearchPosition);

/* Shopify Theme Editor */
document.addEventListener("shopify:section:load", initSearchPosition);

/* Size Guide Link in PDP */

function initSizeGuide() {
  document.addEventListener('click', function (e) {
    const sizeGuideLink = e.target.closest('.fr-size-guide-link');

    if (!sizeGuideLink) return;

    e.preventDefault();

    const sizeGuide = document.getElementById('fr-product-size-guide');

    if (!sizeGuide) return;

    // Open accordion if closed
    if (!sizeGuide.open) {
      sizeGuide.open = true;
    }

    // Wait for accordion to expand
    requestAnimationFrame(function () {
      const header =
        document.querySelector('.shopify-section-header-sticky') ||
        document.querySelector('.header-wrapper') ||
        document.querySelector('header');

      const headerHeight = header ? header.offsetHeight : 0;

      const top =
        sizeGuide.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight -
        20;

      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initSearchPosition();
  initSizeGuide();
});

document.addEventListener('shopify:section:load', function () {
  initSearchPosition();
});